import { ReplenishDataServiceProvider } from './replenish-data-service.provider';
import { ReplenishInventoryDataService } from './replenish-inventory-data.service';
import { ReplenishPendingQtyDataService } from './replenish-pending-qty-data.service';
import { ReplenishQohDataService } from './replenish-qoh-data.service';
import { ReplenishStandWorksheetDataService } from './replenish-stand-worksheet-data.service';

export * from './replenish-inventory-data.service';
export * from './replenish-data.enums';
export * from './replenish-data-service.provider';

export const REPLENISH_DATA_SERVICES = [
  ReplenishInventoryDataService,
  ReplenishQohDataService,
  ReplenishPendingQtyDataService,
  ReplenishStandWorksheetDataService,
];

export const REPLENISH_DATA_SERVICE_PROVIDERS: any[] = [
  REPLENISH_DATA_SERVICES,
  { provide: 'ReplenishDataServices', useValue: REPLENISH_DATA_SERVICES },
  ReplenishDataServiceProvider,
];
